export default __webpack_public_path__ + "static/media/save-disk.cef48c6e.svg";